  @import '../../global/style/all-tenants/custom-properties/components-properties/splide-sliders';

  :host {
    display: block;
    max-width: 100%;
    width: 100%;
    @include cms-base-font-100;
    margin-bottom: var(--cms-components-mb);
  }

  cms-headline {
    --cms-spacing-bottom: var(--cms-spacing-100);
  }

  .category-slider-inner {
    @include cms-default-grid-container;
  }

  .category-slider-container {
    padding: var(--cms-spacing-200) 0 var(--cms-spacing-300) 0;
  }

  .splide {
    @include splide-root;
  }

  .splide__slide {
    @include splide-slide;
  }

  .splide-inner {
    position: relative;
  }

  .splide__track {
    @include splide-track;
  }

  .splide__sr {
    @include splide-sr;
  }

  .splide__list {
    --cms-grid-gap: 0px;
    @include splide-list;
  }

  .splide__slide {
    @include splide-slide;
    background-color: var(--cms-semanticColors-container-weak-background);
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }

  .slide-container {
    text-align: center;
    padding: var(--cms-spacing-075);
    background-color: var(--cms-semanticColors-base-medium-background);
  }

  .category-image {
    width: 100%;
    border-style: none;
    height: auto;
    max-width: 100%;
    vertical-align: middle;
    mix-blend-mode: multiply;
  }

  .button-wrapper {
    width: 100%;
    text-align: center;
    padding: var(--cms-spacing-050);
    box-sizing: border-box;
    flex: 1;
    align-content: center;
  }

  .button-wrapper .detail-link {
    margin: 0 auto;
    max-width: 100%;
    background-color: var(--cms-semanticColors-container-weak-background);
    font-family: var(--cms-brandfont2), serif;
    font-size: var(--cms-font-size-100);
    line-height: var(--cms-line-height-125);
    color: var(--cms-semanticColors-base-strong-text);
    border-style: none;
    padding: var(--cms-spacing-050) 0;
    cursor: pointer;
    vertical-align: middle;
    word-break: break-word;
    word-wrap: break-word;
    overflow-wrap: break-word;

    &:hover {
      text-decoration: underline;
      text-decoration-color: var(--cms-semanticColors-base-strong-border);
      text-decoration-style: solid;
      text-decoration-thickness: 0.125rem;
      text-underline-offset: 0.1875rem;
    }

    &:focus {
      box-shadow: 0 0 0 0.25rem var(--cms-semanticColors-base-focus-outline);
      border-radius: var(--cms-border-radius-xs);
      outline: none;
    }
  }

  .splide-arrow {
    @include splide-arrow;
  }

  .splide__arrow--prev {
    @include splide-arrow-prev;
  }

  .splide__arrow--next {
    @include splide-arrow-next;
  }

  .splide-mobile-pagination {
    @include splide-mobile-pagination;
  }

  @include media-width($breakpoint-sm) {
    cms-headline {
      --cms-spacing-bottom: var(--cms-spacing-150);
    }

    .category-slider-container {
      padding: var(--cms-spacing-200) 0 var(--cms-spacing-200) 0;
    }
  }

  @include media-width($breakpoint-lg) {
    .cms-article-slider-headline {
      font-size: 2.52rem;
    }
  }

  /* Fallback for invalid configuration */
  .invalid-configuration {
    color: var(--cms-theme-text-color);
  }